<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-item label="公司名称">
              <a-input placeholder="请输入公司名称" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>

          <a-col :span="2" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo({},1)" type="primary" />
      <pxkeji-btn name="下载模版" class="pxkeji_basic_btn" @click="downloadTemplate" type="primary" />
      <pxkeji-btn name="导出企业" class="pxkeji_basic_btn" @click="exportData" type="primary" />
      <pxkeji-btn
        name="批量启用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        :roles="['优惠券-启用禁用']"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-upload
        name="file"
        :action="$api.enterprise.importData"
        accept=".xls, .xlsx"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button>
          <a-icon type="upload" />导入企业
        </a-button>
      </a-upload>

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="详情"
            :roles="[]"
            @click="showInfo(action,2)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />
          <pxkeji-btn
            name="员工明细"
            :roles="[]"
            @click="studentInfo(action)"
            size="small"
            type="dashed"
          />
          <a-divider type="vertical" />
          <pxkeji-btn
            name="禁用"
            @click="handleProhibit(action.id,0)"
            size="small"
            type="dashed"
            v-if="action.status==1"
          />
          <pxkeji-btn
            name="启用"
            @click="handleProhibit(action.id,1)"
            size="small"
            type="dashed"
            v-else
          />
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>企业用户人数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="55%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :infos="addedit.info" />
    </a-modal>
    <a-modal
      title="员工明细"
      v-model="student.visible"
      width="75%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <studentRecord @callbackMethod="save" :enterpriseId="student.enterpriseId" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./companyInfo.vue"; //新增编辑
import studentRecord from "./staffList.vue"; //员工明细

const columns = [
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "公司名称",
  },
  {
    dataIndex: "industry",
    key: "industry",
    align: "center",
    title: "行业",
  },
  {
    dataIndex: "legalPerson",
    key: "legalPerson",
    align: "center",
    title: "联系人",
  },
/*  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号",
  },*/
  {
    dataIndex: "address",
    key: "address",
    align: "center",
    title: "公司地址",
  },
  {
    dataIndex: "certificate",
    key: "certificate",
    align: "center",
    title: "组织机构代码证",
  },
  {
    dataIndex: "nature",
    key: "nature",
    align: "center",
    title: "企业性质",
  },
  {
    dataIndex: "enterpriseGroup",
    key: "enterpriseGroup",
    align: "center",
    title: "所属集团",
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "登录账户",
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
var excelLoading = "";

export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false,
      },
      //积分明细
      student: {
        enterpriseId: "",
        visible: false,
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          startTime: "",
          endTime: "",
          address: "",
          company: "",
        },
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false, //弹框
    };
  },
  components: {
    Info,
    studentRecord,
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function () {
      //console.log("watch", val);
    },
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.enterprise
        .getPagedList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.company
        )
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info, type) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "详情";
      }
      this.addedit.visible = true;
      this.addedit.info = info;
      this.addedit.type = type;
    },
    /**积分明细 */
    studentInfo(data) {
      this.student.visible = true;
      this.student.enterpriseId = data.id;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {},
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then((res) => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.operation.coupon
            .removeById(id)
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {},
      });
    },
    /**发券 */
    giveCoupon(id) {
      this.issuing.visible = true;
      this.issuing.id = id;
    },
    /**明细 */
    voidCoupon(id) {
      this.voids.visible = true;
      this.voids.id = id;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    },
    downloadTemplate() {
      window.location.href = this.$api.enterprise.downloadTemplate();
    },
    exportData() {
      window.location.href = this.$api.enterprise.exportData(
        this.where.keyword.company,
        this.selectRows.join()
      );
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleChange(info) {
      if (info.file.status == "uploading") {
        if (excelLoading == "")
          excelLoading = this.$message.loading("上传中", 0);
      } else if (info.file.status == "done") {
        excelLoading();
        excelLoading = "";
        if (info.file.response.errorCode == this.$msg.responseCode.success) {
          this.$message.success(info.file.response.errorMsg);
        } else {
          this.$message.error(info.file.response.errorMsg);
        }
      }
    },
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>